import {
  Dialog,
  DialogContent,
  DialogTitle,
  V2Loader,
  VisuallyHidden,
} from "web-design-system";
import { getRouteApi, useRouter } from "@tanstack/react-router";
import { useSTP } from "creso-core/hooks";
import { AmcLogo } from "@core/components/logo/amc-logo";
import capitalize from "lodash/capitalize";
import { convertToCurrency } from "creso-core/utils";
import { format } from "date-fns";
import { PlanStatusBadge } from "web-core";

export function StpDetails() {
  const clientRoute = getRouteApi("/(auth)/_headed/clients/$id");

  const { client } = clientRoute.useLoaderData();

  const portfolioRoute = getRouteApi("/(auth)/_headed/clients/$id/portfolio");

  const { id = "" } = portfolioRoute.useSearch();

  const { data: stpData, isLoading: isLoadingStp } = useSTP({
    investmentAccountId: client?.investment_account ?? "",
    id: id as string,
  });

  const router = useRouter();

  return (
    <Dialog open onOpenChange={(open) => !open && router.history.back()}>
      <DialogContent>
        <VisuallyHidden>
          <DialogTitle>STP Details</DialogTitle>
        </VisuallyHidden>
        <V2Loader isLoading={isLoadingStp} className="flex flex-col">
          <div className="flex items-center pb-5 gap-4 border-b border-border">
            <AmcLogo
              size="sm"
              amc_code={stpData?.amc_morningstar_code ?? null}
            />
            <span className="text-base text-ellipsis overflow-hidden font-semibold mr-auto">
              {stpData?.switch_in_scheme_name ?? ""}
            </span>
            <PlanStatusBadge status={stpData?.status ?? "ACTIVE"} />
          </div>
          <div className="py-4 flex flex-col gap-4">
            <span className="font-semibold text-sm">Transfer details</span>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <span className="text-sm">Frequency</span>
                <span className="text-sm font-semibold">
                  {capitalize(stpData?.frequency) ?? "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Amount</span>
                <span className="text-sm font-semibold">
                  {convertToCurrency(stpData?.installment_amount ?? 0)}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Start date</span>
                <span className="text-sm font-semibold">
                  {stpData?.start_date
                    ? format(stpData.start_date ?? "", "PP")
                    : "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">
                  {stpData?.status === "COMPLETED"
                    ? "End Date"
                    : "Next transfer"}
                </span>
                <span className="text-sm font-semibold">
                  {stpData?.installment_due_date
                    ? format(stpData?.installment_due_date ?? "", "PP")
                    : "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Transfers completed</span>
                <span className="text-sm font-semibold">
                  {stpData?.no_of_transfers_completed ?? "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Total transferred via STP</span>
                <span className="text-sm font-semibold">
                  {convertToCurrency(
                    stpData?.total_transfer_amount_completed ?? 0
                  )}
                </span>
              </div>
            </div>
          </div>
        </V2Loader>
      </DialogContent>
    </Dialog>
  );
}
